import React from 'react';
import "./standardCard.scss";
import { Fade } from 'react-awesome-reveal';

const StandardCard = ({title, desc}) => {
  return (
    <Fade direction="left" duration={1000} triggerOnce={true} className='standard-card-container' fraction={0.2}>
    <div className="standard-card">
      <h2 className="standard-card-title" dangerouslySetInnerHTML={{ __html: title}} />
      <p className="standard-card-desc" dangerouslySetInnerHTML={{ __html: desc}} />
    </div>
    </Fade>
  )
}

export default StandardCard;